import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import * as Icon from "react-feather";

import { H5, TextLink } from "../../atoms/Texts";

import navToggleDark from "../../../assets/images/menuDark.svg";
import logo from "../../../assets/images/logo.svg";

import { drawerContext } from "../../../shared/store/contexts";
import { HeaderStyle, MenuToggle } from "./styles";
import { PrimaryButton } from "../../atoms/Buttons";
import ProfileDropDown from "../../molecules/ProfileDropdown";

export const SetupHeader = () => {
  const { toggleDrawer } = useContext(drawerContext);

  const [showDropDown, setShowDropDown] = useState(false);

  const toggleDropDown = () => {
    setShowDropDown((prevState) => {
      const newState = !prevState;
      return newState;
    });
  };

  return (
    <HeaderStyle
      bg="#FFFFFF"
      className="container sticky inset-0 mx-auto py-2 md:py-4 flex justify-between items-center"
    >
      {/* LOGO */}
      <Link to="/">
        <img src={logo} alt="" />
      </Link>
      {/* Right Navbar */}
      <div className="flex items-center">
        <div className="hidden md:flex items-center ml-10">
          <Link to="/dashboard/claim-organization" className="mr-10">
            <TextLink color="#716E8B" fontSize="16px" p="9px 16px">
              Claim Organization
            </TextLink>
          </Link>
          <Link to="/dashboard/create-organization" className="">
            <PrimaryButton fontSize="16px" p="9px 16px" className="rounded">
              Create Organization
            </PrimaryButton>
          </Link>
        </div>
        <div className="relative cursor-pointer ml-4">
          <button
            onClick={(e) => {
              e.stopPropagation();
              toggleDropDown();
            }}
            className="dropdown-toggle-btn shadow-none border-0 outline-0 focus:outline-none focus:border-0 flex items-center"
          >
            <div
              className="w-10 h-10 rounded-full flex items-center justify-center object-cover"
              style={{ background: "#EAE7FE" }}
            >
              <H5 color="#12046D" className="capitalize">
                SN
              </H5>
            </div>

            <Icon.ChevronDown size={16} className="" color="#767E85" />
          </button>
          {showDropDown && <ProfileDropDown toggleDropDown={toggleDropDown} />}
        </div>
      </div>
      {/* Mobile Navbar */}
      <nav className="flex md:hidden  justify-between items-center">
        <MenuToggle role="button" className="p-2" onClick={toggleDrawer}>
          <img src={navToggleDark} alt="" className="object-cover" />
        </MenuToggle>
      </nav>
    </HeaderStyle>
  );
};
